import React, { useState, useEffect } from 'react';
import "./CountryCodeModal.css";
import { getDatabase, ref, update } from "firebase/database";
import appFirebase from "../../firebase-config";
import { useUser } from "../../context/UserContext";
import AlertMsg from "../AlertMsg/AlertMsg.jsx";
import AlertMsgError from "../AlertMsg/AlertMsgError.jsx";

const CountryCodeModal = ({ isOpen, onClose }) => {
  const { userData, refreshUserData } = useUser();
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Lista de países con sus códigos de lada
  const countries = [
    { name: 'México', code: '+52', flag: '🇲🇽' },
    { name: 'Estados Unidos', code: '+1', flag: '🇺🇸' },
    { name: 'Canadá', code: '+1', flag: '🇨🇦' },
    { name: 'España', code: '+34', flag: '🇪🇸' },
    { name: 'Argentina', code: '+54', flag: '🇦🇷' },
    { name: 'Colombia', code: '+57', flag: '🇨🇴' },
    { name: 'Venezuela', code: '+58', flag: '🇻🇪' },
    { name: 'Perú', code: '+51', flag: '🇵🇪' },
    { name: 'Chile', code: '+56', flag: '🇨🇱' },
    { name: 'Ecuador', code: '+593', flag: '🇪🇨' },
    { name: 'Bolivia', code: '+591', flag: '🇧🇴' },
    { name: 'Paraguay', code: '+595', flag: '🇵🇾' },
    { name: 'Uruguay', code: '+598', flag: '🇺🇾' },
    { name: 'Brasil', code: '+55', flag: '🇧🇷' },
    { name: 'Guatemala', code: '+502', flag: '🇬🇹' },
    { name: 'Honduras', code: '+504', flag: '🇭🇳' },
    { name: 'El Salvador', code: '+503', flag: '🇸🇻' },
    { name: 'Nicaragua', code: '+505', flag: '🇳🇮' },
    { name: 'Costa Rica', code: '+506', flag: '🇨🇷' },
    { name: 'Panamá', code: '+507', flag: '🇵🇦' },
    { name: 'República Dominicana', code: '+1', flag: '🇩🇴' },
    { name: 'Puerto Rico', code: '+1', flag: '🇵🇷' },
    { name: 'Cuba', code: '+53', flag: '🇨🇺' },
    { name: 'Jamaica', code: '+1', flag: '🇯🇲' },
    { name: 'Francia', code: '+33', flag: '🇫🇷' },
    { name: 'Alemania', code: '+49', flag: '🇩🇪' },
    { name: 'Italia', code: '+39', flag: '🇮🇹' },
    { name: 'Reino Unido', code: '+44', flag: '🇬🇧' },
    { name: 'Portugal', code: '+351', flag: '🇵🇹' },
    { name: 'Países Bajos', code: '+31', flag: '🇳🇱' },
    { name: 'Bélgica', code: '+32', flag: '🇧🇪' },
    { name: 'Suiza', code: '+41', flag: '🇨🇭' },
    { name: 'Austria', code: '+43', flag: '🇦🇹' },
    { name: 'Suecia', code: '+46', flag: '🇸🇪' },
    { name: 'Noruega', code: '+47', flag: '🇳🇴' },
    { name: 'Dinamarca', code: '+45', flag: '🇩🇰' },
    { name: 'Finlandia', code: '+358', flag: '🇫🇮' },
    { name: 'Polonia', code: '+48', flag: '🇵🇱' },
    { name: 'República Checa', code: '+420', flag: '🇨🇿' },
    { name: 'Hungría', code: '+36', flag: '🇭🇺' },
    { name: 'Rumania', code: '+40', flag: '🇷🇴' },
    { name: 'Bulgaria', code: '+359', flag: '🇧🇬' },
    { name: 'Grecia', code: '+30', flag: '🇬🇷' },
    { name: 'Turquía', code: '+90', flag: '🇹🇷' },
    { name: 'Rusia', code: '+7', flag: '🇷🇺' },
    { name: 'Ucrania', code: '+380', flag: '🇺🇦' },
    { name: 'China', code: '+86', flag: '🇨🇳' },
    { name: 'Japón', code: '+81', flag: '🇯🇵' },
    { name: 'Corea del Sur', code: '+82', flag: '🇰🇷' },
    { name: 'India', code: '+91', flag: '🇮🇳' },
    { name: 'Australia', code: '+61', flag: '🇦🇺' },
    { name: 'Nueva Zelanda', code: '+64', flag: '🇳🇿' }
  ];

  useEffect(() => {
    if (selectedCountry) {
      const country = countries.find(c => c.name === selectedCountry);
      if (country) {
        setCountryCode(country.code);
      }
    }
  }, [selectedCountry]);

  // Inicializar el número de teléfono actual del usuario
  useEffect(() => {
    if (userData && userData.phoneNumber) {
      setPhoneNumber(userData.phoneNumber);
    }
  }, [userData]);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handlePhoneChange = (e) => {
    // Solo permitir números y algunos caracteres especiales
    const value = e.target.value.replace(/[^0-9\-\s\(\)]/g, '');
    setPhoneNumber(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCountry || !countryCode) {
      setErrorMessage('Por favor selecciona un país');
      setShowError(true);
      return;
    }

    if (!phoneNumber || phoneNumber.trim() === '') {
      setErrorMessage('Por favor ingresa un número de teléfono válido');
      setShowError(true);
      return;
    }

    setIsLoading(true);

    try {
      const db = getDatabase(appFirebase);
      const userRef = ref(db, `users/${userData.firebaseKey}`);

      await update(userRef, {
        countryCode: countryCode,
        country: selectedCountry,
        phoneNumber: phoneNumber.trim()
      });

      setShowSuccess(true);

      // Actualizar los datos del usuario en el contexto
      if (refreshUserData) {
        refreshUserData();
      }

      setTimeout(() => {
        setShowSuccess(false);
        onClose();
      }, 2000);

    } catch (error) {
      console.error('Error updating country code:', error);
      setErrorMessage('Error al actualizar los datos. Inténtalo de nuevo.');
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="country-code-modal-overlay">
        <div className="country-code-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="country-code-modal-header">
            <h2>Actualizar Datos de Contacto</h2>
            <p>Para completar tu perfil, necesitamos el código de tu país y número de teléfono</p>
          </div>

          <form onSubmit={handleSubmit} className="country-code-form">
            <div className="form-group">
              <label htmlFor="country-select">Selecciona tu país:</label>
              <select
                id="country-select"
                value={selectedCountry}
                onChange={handleCountryChange}
                required
                disabled={isLoading}
              >
                <option value="">-- Selecciona un país --</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.flag} {country.name} ({country.code})
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="phone-input">Número de teléfono:</label>
              <div className="phone-input-container">
                <span className="country-code-display">
                  {countryCode || '+--'}
                </span>
                <input
                  id="phone-input"
                  type="tel"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  placeholder="Ingresa tu número de teléfono"
                  required
                  disabled={isLoading}
                  maxLength="15"
                />
              </div>
              <small className="phone-help">
                Ingresa solo el número sin el código del país
              </small>
            </div>

            {countryCode && phoneNumber && (
              <div className="selected-code">
                <p>Número completo: <strong>{countryCode} {phoneNumber}</strong></p>
              </div>
            )}

            <div className="modal-buttons">
{/*                              <button 
                type="button" 
                onClick={handleClose} 
                className="cancel-btn"
                disabled={isLoading}
              >
                Cancelar
              </button> */}
              <button
                type="submit"
                className="save-btn"
                disabled={isLoading || !selectedCountry || !phoneNumber}
              >
                {isLoading ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showSuccess && (
        <AlertMsg
          visible={showSuccess}
          setVisible={setShowSuccess}
          texto="Datos de contacto actualizados correctamente"
        />
      )}

      {showError && (
        <AlertMsgError
          visible={showError}
          setVisible={setShowError}
          texto={errorMessage}
        />
      )}
    </>
  );
};

export default CountryCodeModal;
